"use client";

import React, { useEffect, useState } from "react";
import Image from "next/image";
import { isMobile } from "@/utils/is";
import makeQrcode from "@/utils/qrcode";
import { useTrack } from "@/hooks/useTrack";
import {
  PRODUCT_BG_VECTOR,
  PRODUCT_DIRECTION,
  MASK_CLOSE_ICON_BLUE,
} from "@/cdn";
import "./index.scss";
import { TrackingPoints } from "../../config";

interface DownloadMaskProps {
  ttLink: string;
  cover?: string | null;
  productId: string | undefined;
  pageId: number | undefined;
  onClose: () => void;
  onDownload: () => void;
}

const DownloadMask: React.FC<DownloadMaskProps> = ({
  ttLink,
  cover,
  productId,
  pageId,
  onClose,
  onDownload,
}) => {
  const { tracking } = useTrack();
  const handleDownload = () => {
    tracking({
      ...TrackingPoints.DownloadMaskLClick,
      page_id: pageId,
      product_id: productId || "",
    });
    onDownload();
  };
  const [qrcode, setQrcode] = useState<string>("");

  useEffect(() => {
    makeQrcode(ttLink).then((qrcode) => {
      setQrcode(qrcode);
    });
    // 曝光埋点
    if (!isMobile()) return;
    tracking({
      ...TrackingPoints.DownloadMaskLExposure,
      page_id: pageId,
      product_id: productId || "",
    });
  }, [ttLink, pageId, productId, tracking]);

  return (
    <div className="yfm-download-mask">
      <div className="yfm-download-mask__content">
        <Image
          src={PRODUCT_BG_VECTOR}
          alt=""
          className="yfm-download-mask__left-icon"
          width={55}
          height={55}
        />
        <Image
          src={PRODUCT_BG_VECTOR}
          alt=""
          className="yfm-download-mask__right-icon"
          width={28}
          height={28}
        />
        <Image
          src={PRODUCT_DIRECTION}
          className="yfm-download-mask__center-icon"
          alt=""
          width={69}
          height={111}
        />
        <Image
          src={MASK_CLOSE_ICON_BLUE}
          alt=""
          className="yfm-download-mask__close-icon"
          onClick={onClose}
          width={16}
          height={16}
        />
        {!isMobile() ? (
          <div className="yfm-download-mask__content-pc">
            <div className="yfm-download-mask__qrcode-wrapper">
              <div className="yfm-download-mask__qrcode-placeholder">
                {qrcode ? (
                  <Image src={qrcode} alt="" width={180} height={180} />
                ) : (
                  <div>Loading QR Code...</div>
                )}
              </div>
            </div>
            <div className="yfm-download-mask__qrcode-text">
              <p>
                <span className="yfm-download-mask__qrcode-text-index">1.</span>
                <span>Open TikTok App</span>
              </p>
              <p>
                <span className="yfm-download-mask__qrcode-text-index">2.</span>
                <span>Scan the QR code</span>
              </p>
              <p>
                <span className="yfm-download-mask__qrcode-text-index">3.</span>
                <span>Add this product to your showcase</span>
              </p>
            </div>
          </div>
        ) : (
          <div className="yfm-download-mask__content-mobile">
            <div className="yfm-download-mask__title">
              Maximize Your Earnings
              <br />
              <div>FREE Samples Inside!</div>
            </div>
            <div className="yfm-download-mask__goods-pic">
              <Image src={cover || ""} alt="" width={180} height={180} />
            </div>
            <div className="yfm-download-mask__desc">
              Get <span>FREE samples</span> to sell better. Earn HIGHER
              commissions and bonus cash! App exclusive
            </div>
          </div>
        )}

        {!isMobile() ? (
          <div className="yfm-download-mask__ok-btn" onClick={onClose}>
            OK
          </div>
        ) : (
          <div
            className="yfm-download-mask__download-btn"
            onClick={handleDownload}
          >
            Download & Unlock
          </div>
        )}
      </div>
    </div>
  );
};

export default DownloadMask;
